<template>
<div id="Home" class="Home">
  <div v-if="alert" :class="['alert', `alert-${alert.color}`, 'mx-5']" width="200" role="alert">
    {{ alert.msg }}
    <div v-if="alert.click">Click <a :href="alert.loc" target="_blank" >Here</a></div>
  </div>

  <!-- Title -->
  <fieldset>
    <legend class="mb-4"><h2>My DEMO Water Softener</h2></legend>
  </fieldset>

  <apexchart v-if="percent >= 10" type='radialBar' height="350" :options="chartOptions" :series="[percent]"></apexchart>
  <div v-else class="alert alert-warning low_alert" role="alert">{{ "Your Salt Level Is low" }}</div>

  <small>Press Refresh to test it out</small>

  <CardsView />

</div>
</template>

<script>
import CardsView from '@/views/CardsView.vue';
var options = { plotOptions: {  radialBar: {    startAngle: -135, endAngle: 225, hollow: {      margin: 0, size: '60%', /* '70%' */      background: '#fff', image: undefined, imageOffsetX: 0, imageOffsetY: 0, position: 'front', dropShadow: {        enabled: true,  top: -3,  left: 0,  blur: 4,  opacity: 0.2      }    }, track: {      background: '#fff', strokeWidth: '150%', /*'67%'*/ margin: 0, /* margin is in pixels */      dropShadow: {        enabled: true,  top: 3,  left: 0,  blur: 4,  opacity: 0.35      }    }, dataLabels: {      show: true, name: { offsetY: -10, color: '#', fontSize: '30px' }, value: { formatter: (val) => `${parseInt(val)}%`, fontSize: '36px', show: true, }    }  }        },  fill: { type: 'gradient', gradient: {    shade: 'dark', type: 'horizontal', shadeIntensity: 0.5, gradientToColors: ['#41B883'], inverseColors: true, opacityFrom: 1, opacityTo: 1, stops: [0, 100]  }        },  stroke: {  lineCap: 'round'  },  labels: ['Percent'],}

export default {
  name: 'Home',
  components: {
    CardsView,
  },
  data() {
    return {

      chartOptions: options,
      
      alert: {
        msg: `Buy your Sensor on Amazon Today!!`,
        click: true,
        loc: 'https://www.amazon.com/dp/B08NC4P47X',
        color: "success"
      },

      percents: [89, 65, 42, 29, 15, 9],
      index: 0,
      percent: 89

    }
  },
  methods: {
    async getDistance() {
      this.percent = this.percents[this.index];
      this.index += 1;

      if (this.index === 6) {
        this.index = 0;
      }
    },
  },

  created() {
    this.getDistance();
  }
}
</script>

<style>
.low_alert {
  margin: 10% 10%;
}
</style>